exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#mobileViewOverlay .ProductsList_products__ZGP_X{padding-top:10px;padding-bottom:10px;border-bottom:1px solid #e7e6e6}#mobileViewOverlay .ProductsList_products__ZGP_X .ProductsList_products__title__ikjia{padding-left:15px;margin-bottom:5px;font-size:12px;color:#9fa0a4}#mobileViewOverlay .ProductsList_products__ZGP_X .ProductsList_products__list__1DqgF{margin:0;padding:0}#GlobalSearchApp .ProductsList_products__ZGP_X{padding-top:10px;padding-bottom:10px;border-bottom:1px solid #e7e6e6}#GlobalSearchApp .ProductsList_products__ZGP_X .ProductsList_products__title__ikjia{padding-left:15px;margin-bottom:5px;font-size:12px;color:#9fa0a4}#GlobalSearchApp .ProductsList_products__ZGP_X .ProductsList_products__list__1DqgF{margin:0;padding:0}@media only screen and (min-width:961px){#GlobalSearchApp .ProductsList_products__ZGP_X .ProductsList_products__title__ikjia{padding-left:10px}}", ""]);

// exports
exports.locals = {
	"greenLight": "#79ff88",
	"greenMain": "#3dcd58",
	"greenDark": "#009530",
	"blueLight": "#7fe6ff",
	"blueMain": "#42b4e6",
	"blueDark": "#0084b4",
	"errorLight": "#ff5a36",
	"errorMain": "#b10043",
	"errorDark": "#c20000",
	"textBlack": "#333333",
	"textGray": "#9b9b9b",
	"textWhite": "#ffffff",
	"grayLight": "#9fa0a4",
	"grayBorder": "#e7e6e6",
	"containerWidthMain": "960",
	"heightDesktopHeader": "136px",
	"products": "ProductsList_products__ZGP_X",
	"products__title": "ProductsList_products__title__ikjia",
	"products__list": "ProductsList_products__list__1DqgF"
};